import axios from 'axios';

const hostUrl = "";

export default {

    // twilio
    getChatToken: (identity) => {
        return axios.get(hostUrl + '/api/chat/getToken', { params: { identity } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // getSubscriptionPlans: () => {
    //     return axios.get(hostUrl + '/api/chat/subscriptionPlans')
    //         .then(res => {
    //             return res.data;
    //         })
    //         .catch(err => {
    //             throw err.response.data;
    //         });
    // },

    // createSubscriptionPlan: (/*planId, */name, call, video, report, amount) => {
    //     return axios.post(hostUrl + '/api/chat/subscriptionPlan', { /*planId,*/ name, call, video, report, amount })
    //         .then(res => {
    //             return res.data;
    //         })
    //         .catch(err => {
    //             throw err.response.data;
    //         });
    // },

    // updateSubscriptionPlan: (id/*, planId*/, name, call, video, report, amount) => {
    //     return axios.put(hostUrl + '/api/chat/subscriptionPlan', { id/*, planId*/, name, call, video, report, amount })
    //         .then(res => {
    //             return res.data;
    //         })
    //         .catch(err => {
    //             throw err.response.data;
    //         });
    // },

    // deleteSubscriptionPlan: (id) => {
    //     return axios.delete(hostUrl + '/api/chat/subscriptionPlan', { params: { id: id } })
    //         .then(res => {
    //             return res.data;
    //         })
    //         .catch(err => {
    //             throw err.response.data;
    //         });
    // },

    // getAllSubscriptionPlans: () => {
    //     return axios.get(hostUrl + '/api/chat/allSubscriptionPlans')
    //         .then(res => {
    //             return res.data;
    //         })
    //         .catch(err => {
    //             throw err.response.data;
    //         });
    // },

    // NOT USED ANYMORE
    // getSubscription: () => {
    //     return axios.get(hostUrl + '/api/chat/subscription')
    //         .then(res => {
    //             return res.data;
    //         })
    //         .catch(err => {
    //             throw err.response.data;
    //         });
    // },

    // createSubscription: (params) => {
    //     return axios.post(hostUrl + '/api/chat/subscription', params)
    //         .then(res => {
    //             return res.data;
    //         })
    //         .catch(err => {
    //             throw err.response.data;
    //         })
    // },

    // updateSubscription: (params) => {
    //     return axios.put(hostUrl + '/api/chat/subscription', params)
    //         .then(res => {
    //             return res.data;
    //         })
    //         .catch(err => {
    //             throw err.response.data;
    //         })
    // },

    getClientProfile: (clientId) => {
        return axios.get(hostUrl + '/api/chat/clientProfile', { params: { clientId } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getConversation: (email) => {
        return axios.get(hostUrl + '/api/chat/conversationsOfUser', { params: { email } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    }
}